module.exports = __webpack_public_path__ + "img/banner1.c345b129.png";